import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { loadCarDocDefinitions } from '@/modules/car/actions/async/load-car-doc-definitions';
import type { TFsmEvent } from '@/modules/onboarding/fsm-types';
import { fsmSelectors } from '@/modules/onboarding/store/fsm-slice';
import { BaseVehicleForm } from '@/pages/VehicleCreate/BaseForm';
import type { IFormProps } from '@/pages/Wizard/view-types';
import { AppDispatch } from '@/root-store';

const Vehicle: React.FC<IFormProps<TFsmEvent>> = ({ onSwitchScreen }) => {
  const dispatch = useDispatch() as AppDispatch;

  const isSubmitting = useSelector(fsmSelectors.isBusy);

  useEffect(() => {
    dispatch(loadCarDocDefinitions());
  }, [dispatch]);

  return (
    <BaseVehicleForm
      onOpenUpload={() => onSwitchScreen('UPLOAD')}
      onFinishSubmit={() => onSwitchScreen('NEXT')}
      onSkipSubmit={() => onSwitchScreen('NEXT')}
      pageNameForEvent="onboarding"
      isSubmitting={isSubmitting}
    />
  );
};

export { Vehicle };
